import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
import upload from "@faire/web-api/api/v2/documents/post";
import { IDocument } from "@faire/web-api/indigofair/data/IDocument";

export const uploadFile = async (file: File): Promise<IDocument> => {
  const formData = new (getWindowOrThrow().FormData)();
  formData.append("file", file);

  // Manually create a blob URL for the file
  const blobURL = getWindowOrThrow().URL.createObjectURL(file);

  const response = await upload(formData);

  // Important this prevents memory leaks by deleting the blob after uploading
  getWindowOrThrow().URL.revokeObjectURL(blobURL);

  return IDocument.build(response);
};
